import { Component, DebugElement, OnInit, ViewChild } from '@angular/core';
import { LoginService } from '../services/login.service';
import { catchError } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { Observable, throwError } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap';
import { Mode } from 'src/modules/shared/form-guide/utility/enums/enums';
import { PopupNotificationComponent } from 'src/modules/shared/request/popup-notification/popup-notification.component';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { EmailLoginService } from '../services/Email-login.service';
import { UserConfigService } from 'src/modules/shared/services/userConfig.service';
import { AppConfigService } from "../../shared/services/app-config.service";
import { EKeyAuthService } from 'src/modules/shared/services/Ekey-auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-email-login',
  templateUrl: './email-login.component.html',
  styleUrls: ['./email-login.component.scss']
})
export class EmailLoginComponent implements OnInit {
  activationStatus: string;

  isSuccessActivationStatus: boolean = false;
  email: string = "";
  password: string = "";
  alertHeader: string;
  alertMsg: string;
  alertModalRef: any;
  loginError: any = "";
  loginCredentials: { Email: string, Password: string };
  isProduction: boolean;
  isEKey2: boolean;
  isEKey: boolean;
  CR_CPR: string;
  //translate: any;
  language: string;
  redirectMessage: any;

  constructor(private loginService: EmailLoginService,
    private appConfig: AppConfigService,
    private modalService: BsModalService,
    private translate: TranslateService,
    private router: Router,
    private authService: EKeyAuthService,
    private activatedRoute: ActivatedRoute) {
    this.isProduction = JSON.parse(this.appConfig.getAppConfig().IsProduction);
    this.isEKey2 = JSON.parse(this.appConfig.getAppConfig().IsEKey2);
    this.isEKey = JSON.parse(this.appConfig.getAppConfig().IsEKey);
    //this.loadConfiguration();
  }

  @ViewChild("loginForm") loginForm: NgForm;
  ngOnInit() {
    this.language= localStorage.getItem('lang');// == 'ar'
    this.activationStatus = this.activatedRoute.snapshot.queryParamMap.get('activationStatus');
    this.isSuccessActivationStatus = this.activationStatus == "Success";
    setTimeout(() => {
      this.activationStatus = '';
      this.isSuccessActivationStatus = false;
    }, 5000);
  }
  navigationExtras: NavigationExtras = {};
  cprValue: string = '';
  invalid: boolean = false;

  // login with EKey 2
  loginWithEKey() {

  debugger;
  console.log('1 - Starting loginWithEKey');
  LoaderService.showLoader();
  console.log('2 - Loader shown');
  
  this.translate.get("Login-container.Labels.LoginRedirectionEKey").subscribe(translatedValue => {
    console.log('3 - Translation received');
    this.redirectMessage = translatedValue;
  });

  console.log('4 - Calling authService.loginWithEKey');
  this.authService.loginWithEKey();
  console.log('5 - After authService call');
}


  //Email login
  onLogin(form: NgForm) {
    if (form.valid) {
      this.invalid = false;
      LoaderService.showLoader();
      this.loginCredentials = { Email: form.value.Email, Password: form.value.Password };
      this.loginService.EmailLogin(this.loginCredentials)

        .pipe(catchError((error) => {
          LoaderService.showLoader();


          return throwError(error);
        }
        )).subscribe((data) => {
          debugger;
          LoaderService.hideLoader();
          if (data.code == 401) {
            this.loginError = "Invalid Email or Password";
            this.loginForm.value.Password = "";
          } else if (data.code == 403) {
            debugger;
            this.loginError = "Email is not verified, please check your inbox";
            this.loginForm.value.Password = "";

          }
          else if (data.code == 200) {
            this.loginError = "";
            this.navigationExtras = { queryParams: { 'ticket': '11224466', 'classSessionId': 'g1dsl2sal183m328jkz', 'token': data.Data.Token } }
            this.router.navigate(['/email-integration'], this.navigationExtras);
          }
        })
    }
    else {
      this.invalid = true;
    }

  }




  //EKey Login
  login() {
    this.navigationExtras = { queryParams: { 'ticket': '11224466', 'classSessionId': 'g1dsl2sal183m328jkz', 'cpr': this.cprValue } }
    // redirect to the login page with extras
    this.router.navigate(['/login'], this.navigationExtras);
  }



  private showErrorModal(isDraft: boolean, message: string) {
    this.alertHeader = 'Validation Message';

    this.alertMsg = message;

    const initialState = {
      alertMode: Mode.Error,
      alertHeader: this.alertHeader,
      alertMassage: `${this.alertMsg} `,
      navigateOnExit: false,
      exitNavigationURL: 'home',
      enableNavigation: true,

    };
    this.alertModalRef = this.modalService.show(PopupNotificationComponent, {
      initialState,
      ignoreBackdropClick: true,
      keyboard: false,
    });
    this.alertModalRef.content.closeBtnName = 'Close';

  }
}

function firstValueFrom(arg0: Observable<boolean>): boolean | PromiseLike<boolean> {
  throw new Error('Function not implemented.');
}

